<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <app-contactrequest :contactPageData='contactPage'></app-contactrequest>
        <app-footer></app-footer>
    </div>
</template>

<script>


    // import { headers } from "../../config";
    import {list_customerUrl, configs} from '../../config';

    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import {listCustomer} from '../../config';
    import FrontFooter from '@/components/partials/FrontFooter';
    import EventBus from '../event-bus';
    import swal from 'sweetalert2/dist/sweetalert2.js';
    const Swal = require('sweetalert2');
    import SessioMixin from '../../mixins/sessionmixin';
    import ListContactRequestComponent from "@/components/contactRequest/ListContactRequestComponent";

    Vue.use(VueGoodTable);

    export default {
        name: "listContactRequests",
        mixins: [SessioMixin],
        components: {
            'app-contactrequest': ListContactRequestComponent,
            'app-footer': FrontFooter,
        },
        data: () => ({
                contactPage: {
                    pageTitle: 'Contact Requests List',
                },
                loginID: 0,
                isLoggedIn: false,
            }),

        mounted: function () {
            var self = this;
            var userObj = localStorage.getItem('filters');
            $(".removeActive").removeClass('active');
            $("#menucontactrequest").addClass('active');
            if (localStorage.getItem("menu_small") == '1') {
                this.menuSmall();
            } else {
                this.menuBig();
            }
            self.showLoader();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                this.loginID = userJson.id;
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }

        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
            }
        },
        methods: {
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }
        }
    };
</script>
<style>
    .vgt-checkbox-col input {
        opacity: 1 !important;
        position: static !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/contactRequest/ContactRequestList.vue